import React from "react";
import type { AgentEditIconProps } from "./AgentEditIcon.types";
import { rawColors } from "../../../design-system/tokens/colors";

/** Exact 16px Edit glyph supplied for the Agents card-action menu. */
export const AgentEditIcon: React.FC<AgentEditIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M8 13.333H14"
      stroke={rawColors.text.mediumEmphasis}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.33316C11.2652 2.06794 11.6249 1.91895 12 1.91895C12.1857 1.91895 12.3696 1.95553 12.5412 2.0266C12.7128 2.09767 12.8687 2.20184 13 2.33316C13.1313 2.46448 13.2355 2.62038 13.3066 2.79196C13.3776 2.96354 13.4142 3.14744 13.4142 3.33316C13.4142 3.51888 13.3776 3.70277 13.3066 3.87436C13.2355 4.04594 13.1313 4.20184 13 4.33316L4.66667 12.6665L2 13.3332L2.66667 10.6665L11 2.33316Z"
      stroke={rawColors.text.mediumEmphasis}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 3.33301L12 5.33301"
      stroke={rawColors.text.mediumEmphasis}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AgentEditIcon;
